// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Call Action Button */
.btn-call-action {
  width: 40px;
  height: 40px;
  min-width: 40px;
  border-radius: 8px;
  background: white;
  border: 1px solid #2ecc71;
  color: #2ecc71;
  font-size: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

.btn-call-action:hover {
  background: #2ecc71;
  color: white;
  box-shadow: 0 4px 8px rgba(46, 204, 113, 0.3);
  transform: translateY(-1px);
}

/* Call Confirmation Modal */
.call-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.55);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.call-modal-content {
  background: white;
  border-radius: 12px;
  width: 90%;
  max-width: 380px;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);
  overflow: hidden;
  animation: callModalAppear 0.3s ease-out;
}

@keyframes callModalAppear {
  from {
    transform: scale(0.9);
    opacity: 0;
  }
  to {
    transform: scale(1);
    opacity: 1;
  }
}

.call-modal-header {
  background: #2ecc71;
  color: white;
  padding: 15px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.call-modal-header h3 {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
}

.call-close-btn {
  background: none;
  border: none;
  color: white;
  font-size: 24px;
  cursor: pointer;
  line-height: 1;
}

.call-modal-body {
  padding: 25px 20px;
  display: flex;
  align-items: center;
  gap: 20px;
}

.call-avatar {
  background: #e8f8f0;
  color: #2ecc71;
  width: 60px;
  height: 60px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 28px;
}

.call-details {
  flex-grow: 1;
}

.call-label {
  color: #7f8c8d;
  font-size: 11px;
  text-transform: uppercase;
  margin: 0 0 2px 0;
  font-weight: 600;
  letter-spacing: 0.5px;
}

.call-value {
  color: #2c3e50;
  font-size: 16px;
  font-weight: 600;
  margin: 0 0 12px 0;
}

.call-value:last-child {
  margin-bottom: 0;
}

.call-modal-footer {
  padding: 15px 20px;
  background: #f8f9fa;
  border-top: 1px solid #eaeded;
  display: flex;
  justify-content: flex-end;
  gap: 12px;
}

.call-btn {
  padding: 8px 18px;
  border: none;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
}

.call-btn-cancel {
  background: #bdc3c7;
  color: white;
}

.call-btn-cancel:hover {
  background: #95a5a6;
}

.call-btn-confirm {
  background: #2ecc71;
  color: white;
}

.call-btn-confirm:hover {
  background: #27ae60;
  box-shadow: 0 2px 6px rgba(46, 204, 113, 0.2);
}
`, "",{"version":3,"sources":["webpack://./src/components/CallButton.css"],"names":[],"mappings":"AAAA,uBAAuB;AACvB;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,yBAAyB;EACzB,yCAAyC;AAC3C;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,6CAA6C;EAC7C,2BAA2B;AAC7B;;AAEA,4BAA4B;AAC5B;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,UAAU;EACV,gBAAgB;EAChB,0CAA0C;EAC1C,gBAAgB;EAChB,wCAAwC;AAC1C;;AAEA;EACE;IACE,qBAAqB;IACrB,UAAU;EACZ;EACA;IACE,mBAAmB;IACnB,UAAU;EACZ;AACF;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;EACd,eAAe;EACf,yBAAyB;EACzB,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,6BAA6B;EAC7B,aAAa;EACb,yBAAyB;EACzB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,6CAA6C;AAC/C","sourcesContent":["/* Call Action Button */\n.btn-call-action {\n  width: 40px;\n  height: 40px;\n  min-width: 40px;\n  border-radius: 8px;\n  background: white;\n  border: 1px solid #2ecc71;\n  color: #2ecc71;\n  font-size: 16px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);\n}\n\n.btn-call-action:hover {\n  background: #2ecc71;\n  color: white;\n  box-shadow: 0 4px 8px rgba(46, 204, 113, 0.3);\n  transform: translateY(-1px);\n}\n\n/* Call Confirmation Modal */\n.call-modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.55);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 9999;\n}\n\n.call-modal-content {\n  background: white;\n  border-radius: 12px;\n  width: 90%;\n  max-width: 380px;\n  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);\n  overflow: hidden;\n  animation: callModalAppear 0.3s ease-out;\n}\n\n@keyframes callModalAppear {\n  from {\n    transform: scale(0.9);\n    opacity: 0;\n  }\n  to {\n    transform: scale(1);\n    opacity: 1;\n  }\n}\n\n.call-modal-header {\n  background: #2ecc71;\n  color: white;\n  padding: 15px 20px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.call-modal-header h3 {\n  margin: 0;\n  font-size: 18px;\n  font-weight: 600;\n}\n\n.call-close-btn {\n  background: none;\n  border: none;\n  color: white;\n  font-size: 24px;\n  cursor: pointer;\n  line-height: 1;\n}\n\n.call-modal-body {\n  padding: 25px 20px;\n  display: flex;\n  align-items: center;\n  gap: 20px;\n}\n\n.call-avatar {\n  background: #e8f8f0;\n  color: #2ecc71;\n  width: 60px;\n  height: 60px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 28px;\n}\n\n.call-details {\n  flex-grow: 1;\n}\n\n.call-label {\n  color: #7f8c8d;\n  font-size: 11px;\n  text-transform: uppercase;\n  margin: 0 0 2px 0;\n  font-weight: 600;\n  letter-spacing: 0.5px;\n}\n\n.call-value {\n  color: #2c3e50;\n  font-size: 16px;\n  font-weight: 600;\n  margin: 0 0 12px 0;\n}\n\n.call-value:last-child {\n  margin-bottom: 0;\n}\n\n.call-modal-footer {\n  padding: 15px 20px;\n  background: #f8f9fa;\n  border-top: 1px solid #eaeded;\n  display: flex;\n  justify-content: flex-end;\n  gap: 12px;\n}\n\n.call-btn {\n  padding: 8px 18px;\n  border: none;\n  border-radius: 6px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.call-btn-cancel {\n  background: #bdc3c7;\n  color: white;\n}\n\n.call-btn-cancel:hover {\n  background: #95a5a6;\n}\n\n.call-btn-confirm {\n  background: #2ecc71;\n  color: white;\n}\n\n.call-btn-confirm:hover {\n  background: #27ae60;\n  box-shadow: 0 2px 6px rgba(46, 204, 113, 0.2);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
